import styled from 'styled-components';

export const ButtonContainer = styled.div`
  a:first-child {
    margin-right: 5px;
  }
`;
